// root '../../../';

// dependencies
// eslint-disable-next-line
import { Child } from 'pym.js';
import React from 'react';
import ReactDOM from 'react-dom';
import Zion from './utils/Zion';

// react components
import App from './components/App.js';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// styles
import './styles/index.scss';

/* develblock:start */
import meta from './data/meta.json';

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: Draw });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    // eslint-disable-next-line
        const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

function Draw() {
  ReactDOM.render(<App />, document.getElementById('graphic'));
}
